import React from "react"
import { Container, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useLang } from "~/hooks/useLang";
import type IDispatch from "../../interfaces/IDispatch";
import { QRCodeCanvas } from "qrcode.react";

interface OccurrenceFormDataProps {
  readonly dispatchResponse: IDispatch;
}

export default function OccurrenceFormData({ dispatchResponse }: OccurrenceFormDataProps) {
  const { translate } = useLang();

  return (
    <Container fixed={false}>
      <Grid container xs={12} sx={{ marginBottom: 2 }}>

        <Grid container xs={12}>
          <Grid item xs={4}>
            <Typography variant='subtitle1'>
              <b>
                {translate('Register number')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.code ?? `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant='subtitle1'>
              <b>
                {translate('Dispatch Group')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.dispatchGroup?.name ? dispatchResponse?.dispatchGroup?.name : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant='subtitle1'>
              <b>
                {`${translate('Date/Time of Registration')}:`}
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dayjs(dispatchResponse?.occurrence?.createdAt).isValid() ? dayjs(dispatchResponse?.occurrence?.createdAt).format('DD/MM/YYYY HH:mm:ss') : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
        </Grid>

        <Grid container xs={8}>
          <Grid item xs={6}>
            <Typography variant='subtitle1'>
              <b>
                {translate('Location')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.occurrence?.location ? dispatchResponse?.occurrence?.location : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant='subtitle1'>
              <b>
                {translate('Reference')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.occurrence?.reference && dispatchResponse?.occurrence?.reference != 'null' ? dispatchResponse?.occurrence?.reference : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant='subtitle1'>
              <b>
                {translate('City')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.occurrence?.city?.name ? dispatchResponse?.occurrence?.city?.name : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant='subtitle1'>
              <b>
                {translate('District')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.occurrence?.district?.name ?? `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant='subtitle1'>
              <b>
                {translate('Finalization')}
                :
              </b>
            </Typography>
            <Typography variant='subtitle2'>
              {dispatchResponse?.closedStatus.name ? dispatchResponse?.closedStatus.name : `* ${translate('Uninformed')} *`}
            </Typography>
          </Grid>
        </Grid>
        <Grid container xs={4} >
          <Grid item xs={12}>

            <Typography variant='subtitle1'>
              <b>
                {translate('QR Code')}
                :
              </b>
            </Typography>
            <QRCodeCanvas
              value={`Registro : ${dispatchResponse?.code ?? `* ${translate('Uninformed')} *`}\nLocal : ${dispatchResponse?.occurrence?.location ? dispatchResponse?.occurrence?.location : `* ${translate('Uninformed')} *`}\nTipo do Chamado : ${dispatchResponse?.type?.name ? `${dispatchResponse?.type?.name} ${dispatchResponse?.subtype?.name ? dispatchResponse?.subtype?.name : ''}` : `* ${translate('Uninformed')} *`}\nStatus : ${dispatchResponse?.status?.name ? dispatchResponse?.status?.name : `* ${translate('Uninformed')} *`}\nFinalizado : ${dispatchResponse?.closedStatus?.name ? dispatchResponse?.closedStatus?.name : `* ${translate('Uninformed')} *`}
            `}
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}